import { Cache, MapnikMap } from '../classes';

export class GeoService {
  id: number;
  name: string;
  title: string;
  cache: Cache;
  url: string;
  type: 'tms' | 'wms' | 'geojson';
  map: MapnikMap;
  time = false;
  checked = false;
  folder: GeoFolder;
  owner: string;
  projects: string[];
  sourcesNames: string[];
  sources: any[];
  last_change: Date;
  internal = false;
  isChanged = false;

  constructor(data?: GeoServiceOptions) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: GeoServiceOptions) {
    // подстановка алиасов из атрибутов слоя
    if (data.map && data.map.layers) {
      data.map.layers.forEach(layer => {
        layer.style.rules.forEach(rule => {
          rule.rule_items.forEach(item => {
            if (item.content_object.attributes) {
              item.content_object.attributes.forEach((attribute: any) => {
                const layerAttribute = layer.attributes.find(attr => attr.name === attribute.name);
                if (layerAttribute) {
                  attribute.alias = layerAttribute.alias;
                }
              });
            }
          });
        });
      });
    }
    Object.assign(this, data);
  }
}

export interface GeoServiceOptions {
  id?: number;
  name?: string;
  title?: string;
  cache?: Cache;
  url?: string;
  type?: 'tms' | 'wms';
  map?: MapnikMap;
  time?: boolean;
  checked?: boolean;
  folder?: GeoFolder;
  owner?: string;
  projects?: string[];
  sourcesNames?: string[];
  sources?: GeoSource[];
  last_change?: Date;
  internal?: boolean;
}

export class GeoFolder {
  id?: number;
  title: string;
  services?: GeoService[];
  type?: 'default' | null;
  owner: string;
  last_change: Date;

  constructor(options?: GeoFolderOptions) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export interface GeoFolderOptions {
  id?: number;
  title?: string;
  services?: GeoService[];
  type?: 'default' | null;
  owner?: string;
  last_change?: Date;
}

export interface GeoSource {
  type: 'db' | 'folder';
  table: string;
  schema: string;
  name: string;
  source: string;
  mosaic: boolean;
}
